// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"64da5459","238":"9202a876"}[chunkId] + ".chunk.js";
};